// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"64":"3f8a94bf91757cda","600":"3db1de1d8f432db2","970":"52e863615260d4cd"}[chunkId] + ".js";
};